import React from 'react'
import './AboutUs.css'
import Header from '../Header/Header'
import Footer from '../Footer/Footer'
import abts_whower_img from '../../assets/abts_whower_img.webp'
import abts_ourViss_img from '../../assets/abts_ourViss_img.webp'
import abts_ourMiss_img from '../../assets/abts_ourMiss_img.webp'
import ourTeam_img1 from '../../assets/ourTeam_img1.webp'
import ourTeam_img2 from '../../assets/ourTeam_img2.webp'
import ourTeam_img3 from '../../assets/ourTeam_img3.webp'
import ourTeam_img4 from '../../assets/ourTeam_img4.webp'
import { FaArrowUpRightFromSquare } from "react-icons/fa6";
import { Link } from 'react-router-dom'
import { toast } from "react-hot-toast";

const AboutUs = () => {

    const showerrorToast = (message) => {
        toast.dismiss();
        toast.error(message);
    };

    const connectwalletToast = () => {
        showerrorToast("Connect wallet");
    }

  return (
        <>
          <Header />
    
          <main className="aboutUs_main">
            <section className="aboutUs_hero">
              <div className="container-md">
                <h1 className="aboutUs_title">
                  About <span className='us'>Us</span> - <span className='Assetly'>Assetly</span>
                </h1>
                <p className="aboutUs_cnt">
                  Assetly is a next-generation platform that transforms real-world assets (RWA) into secure, 
                  tradeable digital tokens. We bridge the gap between traditional finance and blockchain technology, 
                  enabling businesses, institutions, and investors to unlock new opportunities with transparency, 
                  efficiency, and trust.
                </p>
              </div>
            </section>

            <section className='abtus_countSec'>
                <div className='abtus_countwrp'>
                    <div className='abtus_countItem'>
                        <span>$1B+</span>
                        <div className='count_text'>
                            <h2>Assets</h2>
                            <h2>Tokenized</h2>
                        </div>
                    </div>
                    <div className='abtus_countItem'>
                        <span>100K+</span>
                        <div className='count_text'>
                            <h2>Active</h2>
                            <h2>investors</h2>
                        </div>
                    </div>
                    <div className='abtus_countItem'>
                        <span>24/7</span>
                        <div className='count_text'>
                            <h2>Global</h2>
                            <h2>Trading</h2>
                        </div>
                    </div>
                    <div className='abtus_countItem'>
                        <span>99.9%</span>
                        <div className='count_text'>
                            <h2>Uptime</h2>
                            <h2>Guarantee</h2>
                        </div>
                    </div>
                </div>
            </section>

            <section className='miss_viss_sect'>
                <div className='miss_viss_row'>
                    <div className='miss_viss_col'>
                        <div className='abts_rowWise_img'>
                            <img src={abts_whower_img} alt='abts_whower_img' />
                        </div>
                    </div>
                    <div className='miss_viss_col'>
                        <div className='miss_viss_cnt'>
                            <h4>Who <span>We Are</span></h4>
                            <p>Assetly is fundamentally changing how real-world assets are owned, managed, and traded. 
                                Built on a vision to democratize asset ownership, we provide a cutting-edge, 
                                secure platform that enables businesses and investors to easily tokenize a wide array of assets—from prime real estate and private equity 
                                to valuable collectibles and infrastructure projects.By transforming traditional, illiquid assets into digital tokens on the blockchain, 
                                Assetly makes them accessible, fractional, and tradable globally.</p>
                            <p>
                                 Ultimately, tokenization democratizes investment by lowering the minimum investment threshold, 
                                 increasing transparency, reducing transaction costs, and creating global, 
                                 24/7 liquidity for virtually any asset class.
                            </p>
                            <button onClick={connectwalletToast} ><Link to={""}>Learn More</Link></button>
                        </div>
                    </div>
                </div>
                <div className='miss_viss_row'>
                    <div className='miss_viss_col'>
                        <div className='miss_viss_cnt'>
                            <h4>Our <span>Mission</span></h4>
                            <h5>To unlock opportunities for individuals and institutions by creating a trusted gateway for tokenized assets.</h5>
                            <p>We are committed to building the essential infrastructure that bridges the traditional financial world with the decentralized future. 
                            By providing a secure, compliant, and easy-to-use platform, we empower everyone—from the first-time investor to the largest institutional 
                            fund—to participate in the revolution of asset ownership. We turn illiquidity into opportunity.</p>
                        </div>
                    </div>
                    <div className='miss_viss_col'>
                        <div className='abts_rowWise_img'>
                            <img src={abts_ourMiss_img} alt='abts_ourMiss_img' />
                        </div>
                    </div>
                </div>
                <div className='miss_viss_row'>
                    <div className='miss_viss_col'>
                        <div className='abts_rowWise_img'>
                            <img src={abts_ourViss_img} alt='abts_ourViss_img' />
                        </div>
                    </div>
                    <div className='miss_viss_col'>
                        <div className='miss_viss_cnt'>
                            <h4>Our <span>Vision</span></h4>
                            <h5>A future where ownership is digital, investments are borderless, and trust is built into every transaction.</h5>
                            <p>We envision a world where the barriers of traditional finance are eliminated. In this future, 
                                assets are natively digital, allowing for instant, global, 24/7 trading. Trust isn't dependent on intermediaries; 
                                it's built directly into the technology through transparent, immutable blockchain records. 
                                This is a future of true financial democratization.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className='abts_ourTeam'>
                <div className='abts_ourTeam_wrp'>
                    <h6>Our Team</h6>
                    <div className='ourTeam_membr'>
                        <div className='ourTeam_membrItm'>
                            <img src={ourTeam_img1} alt='ourTeam_img1' />
                            <h6>Philip larson</h6>
                            <p>CEO</p>
                        </div>
                        <div className='ourTeam_membrItm'>
                            <img src={ourTeam_img2} alt='ourTeam_img2' />
                            <h6>Maria Chen</h6>
                            <p>CTO</p>
                        </div>
                        <div className='ourTeam_membrItm'>
                            <img src={ourTeam_img3} alt='ourTeam_img3' />
                            <h6>David Lee</h6>
                            <p>Head of Compliance</p>
                        </div>
                        <div className='ourTeam_membrItm'>
                            <img src={ourTeam_img4} alt='ourTeam_img4' />
                            <h6>Jimm Nelson</h6>
                            <p>Project Manager</p>
                        </div>
                    </div>
                </div>
            </section>

              <section className="abts_join_section">
                  <h6>Join the Assetly Revolution!</h6>
                  <p>
                      Real Assets. Real Returns. On Chain.
                  </p>
                  <div className="abts_join_btn_grup">
                      <button
                          className="started_btn"
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal" >
                          <span>Start Investing </span>
                      </button>


                      <button className="institions_btn" >
                          <Link to={"/institution"} >For Institutions <FaArrowUpRightFromSquare /></Link>
                      </button>
                  </div>
              </section>

          </main>
    
          <div className="inst_footer_wrap">
            <Footer />
          </div>
        </>
  )
}

export default AboutUs